import { FC, lazy, ReactNode } from 'react';

const Footer = lazy(
  () => import('@sky-distribution/gp-onboarding-mf-footer'),
);
const FAQ = lazy(() => import('@sky-distribution/gp-onboarding-mf-faq'));

type LogoIds = 'compensaLogo' | 'securityLock' | 'knfLogo';

type FooterI18nResources = {
  lang: string;
  resources: {
    faq?: {
      label: string;
      list: { question: string; answer: string }[];
    };
    links?: { href: string; label: string }[];
    documents?: {
      label?: string;
      list: { href: string; label: string }[];
    };
  };
};

interface BasicPageLayoutProps {
  form: ReactNode;
  footerI18n: FooterI18nResources[];
  footerDisplay?: LogoIds[];
}

export const BasicPageLayout: FC<BasicPageLayoutProps> = ({
  form,
  footerI18n,
  footerDisplay = ['knfLogo', 'securityLock'],
}) => (
  <>
    {form}
    <Footer display={footerDisplay} />
    <FAQ footerI18nResources={footerI18n} />
  </>
);
